<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <div style="margin-top: 2.66667vw;">
      <div class="goods-list" v-for="(item,index) in goodsList" :key="index">
<!--        <div class="item-goods left-justifying" v-for="(item,index) in goodsList" :key="index">-->
<!--          <div class="lf-box left-justifying">-->
<!--            <div>-->
<!--              <img v-if="item.isGood" class="cart-checkbox" :src="selectActive" @click="chooseGoodSelectDefault(index)" />-->
<!--              <img v-if="!item.isGood" class="cart-checkbox" :src="selectDefault" @click="chooseGoodSelect(index)" />-->
<!--            </div>-->
<!--            <img class="goods-img" :src="item.image" alt="" />-->
<!--          </div>-->
<!--          <div class="goods-content" @click="goDesGood(item.goods_id)">-->
<!--            <div class="good-title">{{item.name}}</div>-->
<!--            <div class="goods-price">x{{item.number}}</div>-->
<!--          </div>-->
<!--        </div>-->
              <van-card
                :title="item.name"
                :num="item.number"
                :thumb="item.image"
                @click="goDesGood(item.goods_id)"
              />
      </div>
    </div>
    <div class="input-box">
      <div class="msg-box">
        <van-field
          v-model="message"
          rows="2"
          style="background: #EFEFEF;"
          autosize
          type="textarea"
          maxlength="255"
          placeholder="请输入您的申请退货退款理由(必填)"
          show-word-limit
        />
      </div>
      <div class="pic-box">
        <div class="title">图片</div>
        <div class="posting-uploader">
          <div class="posting-uploader-item" v-for="(item, nn) in postData" :key="nn">
            <img :src="item" alt="图片" class="imgPreview" />
            <van-icon name="clear" size="30"  @click="delImg(nn)"  class="delte" />
          </div>
          <van-uploader :after-read="afterReadPic" :accept="'image/*'" v-show="postData.length <= 2" result-type="text" @oversize="onOversize" :before-read="beforeRead">
            <img
              :src="require('../../assets/'+appTheme+'/up_pic.png')"
              alt="等待传图"
              class="imgPreview"
            />
          </van-uploader>
        </div>

        <!--      <van-uploader v-model="fileList" multiple :max-size="5000 * 1024" @oversize="onOversize" :before-read="beforeRead" :after-read="afterReadPic" @delete="beforeDel" :max-count="3" />-->
      </div>
    </div>
    <div style="padding-bottom: 4vw;">
      <van-button style="width: 90%;display: block;margin: 6.66667vw auto 2.66667vw;font-weight: bold;background: #FDD80D;border: none;color: #282828;" round type="primary" @click="submitSalesReturn" :disabled="isDisable">提交</van-button>
    </div>

  </div>
</template>


<script>
import {orderRefund, orderListDes} from '@/api/order'
import upLoaderImg from "@/api/upLoaderImg";
export default {
  name: "orderSalesReturn",
  data(){
    return {
      appTheme:this.$store.state.appTheme,
      selectActive: require('@/assets/'+this.$store.state.appTheme+'/select_active.png'),
      selectDefault: require('@/assets/'+this.$store.state.appTheme+'/select.png'),
      orderInfo: '',
      message: '',
      isDisable: false,
      goodsList: [],
      checked:0,
      user_id: 0, // 用户id, 值为0则匿名
      orderId: '',
      fileList: [],
      postData:[]
    }
  },
  created() {
    this.orderId = this.$route.query.id
    // var item = this.$route.query.item
    //
    // this.orderInfo = JSON.parse(item)
    this.getInfoOrder()
  },
  methods:{
    submitSalesReturn(){
      if (this.message==''){
        this.$toast('请输入理由')
        return false
      }else {
        this.isDisable= true
        const data = {
          reason:this.message,
          image_url:this.postData
        }
        orderRefund(this.orderId, data).then(res => {
          if(res.code == 200)
          {
            this.$dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.$router.push({path:'/orderDes',query: {id:this.orderId}})
            });
          }
          else
          {
            this.$toast(res.message)
            this.isDisable= false
            // this.$router.push('/');
          }
        })
      }
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    delImg(index){
      console.log(index);
      // 删除指定下标的图片对象
      if (isNaN(index) || index >= this.postData.length) {
        return false
      }
      this.postData.splice(index, 1)
    },
    async afterReadPic(file){ // 上传图片
      var data = {
        file: file.file,
        module:'refund'
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        let img = res.data.source_url
        let arr = this.postData
        arr.push(img)
        this.postData = arr
        console.log(this.postData)
      } else {
        this.$toast(message)
      }
    },
    beforeRead (file) {	//上传之前校验
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$toast('只允许上传jpg/png格式的图片！')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file);
      this.$toast('文件大小不能超过 5000kb');
    },
    goDesGood(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
    getInfoOrder(){
      orderListDes(this.orderId).then(res => {
        if(res.code == 200)
        {
          this.orderInfo = res.data
          this.goodsList = res.data.order_goods
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
  }
}
</script>

<style lang="scss" scoped>
.van-card__num{
  opacity: 0;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.goods-list{
  margin: 0 24px;background: #FFFFFF;padding: 20px;border-bottom: 2px solid #F5F5F5;
  border-radius: 10px;
  .item-goods{
    margin-bottom: 30px;
    .cart-checkbox{
      width: 36px;margin-right: 20px;display: inline-block;
    }
    .goods-img{
      width: 140px;height: 140px;display: inline-block;margin-right: 20px;
    }
    .good-title{
      overflow: hidden;
      text-align: left;
      width: 430px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .goods-price{
      color: #666666;margin-top: 20px;
    }
  }
}
.input-box{
  margin: 0 24px;background: #FFFFFF;padding: 20px;
}
.pic-box{
  margin-top: 20px;
  .title{
    padding: 15px 0;
  }
}
.van-card{
  background: #fff;padding-left: 0;
}
.van-card__price{
  color: #F23926;
}
.msg-box{

  .title{
    font-weight: bold;padding: 20px 0;
  }
  background: #FFFFFF;
  .submit-box{
    padding: 30px 0 10px;
  }
}
.submit-btn{
  display: block;background: #FDD80D;font-size: 30px;
  border-radius:50px;border: none;
  color: #282828;width: 25%;
}
.van-cell{
  border-radius: 8px;
}
textarea::-webkit-input-placeholder {

  color: #909090;
  /* placeholder位置  */
}

.image {
  width: 50px;
  height: 50px;
}
.uploader {
  display: flex;
  flex-direction: row;
}
.posting-uploader {
  display: flex;
  flex-direction: row;
}

.posting-uploader-item {
  position: relative;
  width: 150px;
  height: 150px;margin-right: 20px;
  .delte {
    position: absolute;right: 0;top: 0;z-index: 2;color: #e30f0f;
  }
}
.imgPreview {
  width: 150px;
  height: 150px;
}

.upload-img-5 {
  margin: 5px 0 90px 0;
}
.upload-img-1 {
  margin: 5px 0 15px 0;
}

</style>
